import { toNumber } from "../pages/homework/utils/filter";
import { CourseItem, workState } from "./index";

export interface CourseParams {
    courseNo: string;
    courseSeq: string;
    weekTime: string; // 周次
    week: string; // 星期几
    section: string;
    continunity: string;
}

/**
 *
 * @param courseNo
 * @param courseSeq
 * @param weekTime
 * @param week
 * @param section
 * @param continunity
 */
export function makeCourseParams({
    courseNo,
    courseSeq,
    week,
    weekTime,
    section,
    continunity
}: CourseParams) {
    return `${courseNo}/${courseSeq}/${weekTime}/${
        toNumber(week) - 1
    }/${section}/${continunity}`;
}

export function makeCourseParamsFromCourse(course: CourseItem) {
    return {
        courseSeq: course.courseSeq,
        courseNo: course.courseNo,
        continunity: course.continunity,
        weekTime: course.weekNo,
        week: course.dayOfWeek,
        section: course.section
    };
}

/**
 * 课程详情
 * @param courseNo
 * @param courseSeq
 * @param weekTimeId
 * @param path
 */

export function courseDetailUrl(
    courseNo: string,
    courseSeq: string,
    weekTimeId: number,
    path: string = "chapter"
) {
    return `/course/detail/${courseNo}/${courseSeq}/${weekTimeId}/${path}`;
}

/**
 * 课程详细作业
 * @param weekTimeId
 * @param params
 */
export function courseDetailHomeworkUrl(
    weekTimeId: number,
    params: CourseParams
) {
    const courseParams = makeCourseParams(params);
    return `/course/detail/${weekTimeId}/homework/${courseParams}`;
}

/**
 * 做作业页面
 * @param courseNo
 * @param section
 * @param week
 * @param weekTime
 * @param continunity
 * @param courseSeq
 * @param weekTimeId
 * @param paperId
 * @param homeworkStatus
 * @constructor
 */
export function homeworkDetailUrl({
    courseNo,
    section,
    week,
    weekTime,
    continunity,
    courseSeq,
    weekTimeId,
    paperId,
    homeworkStatus
}: CourseParams & {
    homeworkStatus: workState;
    paperId: string;
    weekTimeId: number;
}) {
    let status: string = homeworkStatus;

    if (homeworkStatus === "3") {
        status = "1";
    }
    if (homeworkStatus === "4") {
        status = "2";
    }

    let base64 = window.btoa(
        `${courseNo}-${courseSeq}-${weekTime}-${week}-${section}-${continunity}-${status}-${paperId}-${weekTimeId}`
    );
    return `/homework/${base64}`;
}
